import type { FC } from "react";
import { memo } from "react";

import Button, { type IButton } from "@/design-system/button";
import { languageSelector } from "@/src/contexts";
import { defaultToTrue } from "@Components/Modules/Helpers";
import * as stylex from "@stylexjs/stylex";

import { ComposableSpacing, type PropsWithStyleX, colors } from "../../../styles/tokens.stylex";
import { WebpageLinkResources } from "./WebpageLink.Resources";
import { WebpageLinkResourcesEn } from "./WebpageLink.Resources.En";

interface IWebpageLink extends PropsWithStyleX {
    href: string;
    variant?: IButton["variant"];
    size?: IButton["size"];
    text?: string;
}

const WebpageLink: FC<IWebpageLink> = memo((props) => {
    const { text } = languageSelector(WebpageLinkResources, WebpageLinkResourcesEn);

    return (
        <Button
            as="a"
            size={props.size || "None"}
            variant={props.variant || "transparent"}
            href={props.href}
            target="_blank"
            styleX={[styles.webpageLinkComponent, props.styleX]}
        >
            {props.text || text}
        </Button>
    );
}, defaultToTrue);

const styles = stylex.create({
    webpageLinkComponent: {
        color: colors.fg_Accent,

        "::before": {
            color: colors.b_BrandMagenta,
            content: "\\2794",
            display: "inline-block",
            fontSize: "1.7rem",
            lineHeight: 1,
            transform: "rotate(310deg)",
            paddingRight: ComposableSpacing.s1,
        },
    },
});
export default WebpageLink;
